console.log('Locations embed…');
